export enum Colors {
  INHERIT = 'inherit',
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  DEFAULT = 'default',
}
